import * as MiscConstants from '../constants/Misc'
import { getAccount } from './api'

export const createSession = (jwt, shoudFetchAccount = true) => async dispatch => {
  await dispatch({ type: MiscConstants.CREATE_SESSION, jwt })
  if (shoudFetchAccount) {
    await dispatch(getAccount())
  }
}

export const resetPhoneUpdate = () => ({
  type: MiscConstants.RESET_PHONE_UPDATE
})

export const setProfileData = data => ({
  type: MiscConstants.SET_PROFILE_DATA,
  payload: data
})

export const setDiscounts = data => ({
  type: MiscConstants.SET_DISCOUNTS,
  payload: data
})
